import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import useOrderPriceSelector from "_redux/hooks/useOrderPriceSelector";
import Grid from "@mui/material/Unstable_Grid2";
import { formatCurrency } from "tools/stringUtils";
import PriceRow from "./PriceRow";

const CartPriceSummary: FC = () => {
  const { t } = useTranslation();
  const orderPrice = useOrderPriceSelector();

  return (
    <Grid container xs={12} sm={4}>
      <PriceRow
        label={t("cart.products")}
        labelVariant="body2"
        value={formatCurrency(orderPrice.totalProduct)}
      />

      {orderPrice.totalAdjustment !== 0 && (
        <PriceRow
          label={t("cart.promotionCode")}
          labelVariant="body2"
          value={formatCurrency(orderPrice.totalAdjustment)}
        />
      )}

      <PriceRow
        label={t("cart.shippingCosts")}
        labelVariant="body2"
        value={formatCurrency(orderPrice.totalShipping)}
      />

      <PriceRow
        label={t("cart.total")}
        value={formatCurrency(orderPrice.total)}
        labelVariant="body2"
        valueVariant="h2"
        labelMarginRight={1}
        bold
      />
    </Grid>
  );
};

export default CartPriceSummary;
